import { type ReactElement } from 'react'

import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import KNDetailsPopoverSection from './KNDetailsPopoverSection'
import type { KNDetailsPopoverListProps } from './types'

const KNDetailsPopoverList = ({ header, description, items }: KNDetailsPopoverListProps): ReactElement | null => {
  if (!description && items.length === 0) {
    return null
  }
  return (
    <KNDetailsPopoverSection
      header={header}
      description={description}
      items={items.map((item, index) => (
        <Stack
          key={item.label ?? index}
          spacing={item.stacked ? 0 : 4}
          direction={item.stacked ? 'column' : 'row'}
          alignItems={item.stacked ? 'start' : 'center'}
          justifyContent="space-between"
          sx={{
            paddingX: 2,
            paddingY: 0.25,
            '&:hover': {
              backgroundColor: 'primary.dark',
            },
          }}
        >
          {item.label && (
            <Typography variant="p6" color="primary.light">
              {item.label}
            </Typography>
          )}
          {item.value && (
            <Typography
              color="inherit"
              fontSize="0.75rem"
              textAlign={item.stacked ? 'left' : 'right'}
              sx={{
                lineHeight: '20px',
              }}
            >
              {(Array.isArray(item.value) ? item.value : [item.value]).map((value, index) => (
                <Box key={item.label ?? index} component="span">
                  {index !== 0 && ', '}
                  {value}
                </Box>
              ))}
            </Typography>
          )}
        </Stack>
      ))}
    />
  )
}

export default KNDetailsPopoverList
